/* stylelint-disable selector-max-compound-selectors */
:host {
  @include reset-host;
  @include reset-list;
  @include reset-media;
}

:host .landing-page-layout {
  --footer--top-background-color: #{$white};
}

:host .pack-card-list {
  display: flex;
  gap: map-get($spacing-sizes, 2);
  width: 100%;

  @include mq('max', 'md') {
    flex-direction: column;
  }

  .item {
    flex: 1;
  }
}

:host .video-card-list {
  display: flex;
  gap: map-get($spacing-sizes, 4);
  justify-content: center;

  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-padding-left: $gutter-mobile;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;

  @include mq('max', 'lg') {
    justify-content: flex-start;
  }

  @include mq('max', 'md') {
    gap: map-get($spacing-sizes, 2);
    margin: 0 calc($gutter-mobile * -1);
    padding: 0 $gutter-mobile;
  }

  &::-webkit-scrollbar {
    display: none;
  }

  &.has-one-item {
    @include mq('max', 'lg') {
      justify-content: center;
    }
  }

  .item {
    min-width: rem(296);
  }
}

:host .ai-ccident-section {
  --paragraph-color: #{$white};
  display: flex;
  align-items: center;

  @include mq('max', 'md') {
    flex-direction: column-reverse;
    gap: map-get($spacing-sizes, 4);
  }

  .text-wrapper {
    display: flex;
    flex: 3;
    flex-direction: column;
    align-items: flex-start;
  }

  .image-wrapper {
    flex: 2;

    @include mq('max', 'md') {
      max-width: rem(400);
      margin: 0 auto;
    }

    img {
      width: 100%;
      height: auto;
    }
  }
}

:host .centered-text {
  display: flex;
  flex-direction: column;
  align-items: center;

  text-align: center;
}
